
import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

@Component
export default class LiterField extends Vue {
  val = '';

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  placeholder!: string;

  @Model('change', {
    type: String,
  })
  value!: string;

  @Watch('val')
  watchVal() {
    this.$emit('update', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = `${this.value}`;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
